import { CategoryTree } from '~/modules/GraphQL/types';

export interface Slide {
  text: string | undefined;
  image: string;
}

export const getCategoryBannerSlides = (category?: CategoryTree | undefined): Slide[] => {
  const slides: Slide[] = [];

  if (!category) {
    return slides;
  }

  // add main image as first slide if it is set
  if (category.image) {
    slides.push({
      text: category.description,
      image: category.image,
    })
  }

  // add additional images
  for (let i = 2; i <= 5; i++) {
    if (!category['image' + i]) {
      continue;
    }

    slides.push({
      text: category['image' + i + '_description'] || category.description,
      image: category['image' + i],
    })
  }

  // if there was no images at all but there is a description then add slide with description and without image
  if (!slides.length) {
    slides.push({
      text: category.description,
      image: '/general/404.jpeg',
    })
  }

  return slides;
}
